import cloneDeep from 'lodash.clonedeep';

import baseView from '../../base-view';
import recaptcha from './recaptcha';
import template from './template.hbs';

const baseViewFn = baseView.make();
const captcha = baseView.make();

captcha.template = template;
captcha.widgetId = null;

captcha.getContext = function() {
  return {
    id: 'captcha',
    field: 'captcha',
    required: true,
  };
};

captcha.getWidgetConfig = function() {
  const context = this.getContext();
  const input = this.el.querySelector(`#${context.id}`);

  const triggerInputChange = () => {
    const event = new window.Event('change', { bubbles: true });

    input.dispatchEvent(event);
  };

  const updateInput = () => {
    input.value = window.grecaptcha.getResponse(this.widgetId);
    triggerInputChange();
  };

  const clearInput = () => {
    input.value = '';
    triggerInputChange();
  };

  return {
    callback: updateInput,
    'expired-callback': clearInput,
    sitekey: this.sitekey,
    tabindex: this.tabindex,
  };
};

captcha.render = function() {
  const init = Promise.all([
    baseViewFn.render.call(this),
    recaptcha.load(),
  ]);

  const renderWidget = () => {
    const container = this.el.querySelector('.captcha-container');
    const config = this.getWidgetConfig();

    this.widgetId = window.grecaptcha.render(container, config);
  };

  return init.then(renderWidget);
};

const make = cloneDeep.bind(null, captcha);

export default {
  make,
};
